import { makeStyles } from "tss-react/mui";
import { z } from "zod";
import { MiContentDrawer, MiDetailFields } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { useEdit } from "@miplatform/hooks";
import { mdiToolbox } from "@mdi/js";

const initialData = {
  name: "",
};

export function AddTradeDrawer({
  onClose,
  onSubmit,
  loading,
  attemptTypes,
  title,
  trade = null,
  ...rest
}) {
  const { classes } = useStyles();
  const tradeFields = [
    {
      label: "Trade Name",
      name: "name",
      width: "100%",
      validationRule: z
        .string()
        .min(2, "Trade name is too short!")
        .max(255, "Trade name is too long!"),
    },
  ];
  const edit = useEdit(trade || initialData, tradeFields);

  const handleSubmit = () => {
    onSubmit({ ...edit.edits, modifiedOn: edit.getValue("modifiedOn") });
    edit.reset();
  };

  const handleDrawerClose = () => {
    onClose();
    edit.reset();
  };

  return (
    <MiContentDrawer
      variant="temporary"
      leftIcon={mdiToolbox}
      isLoading={loading}
      title={title}
      onClose={handleDrawerClose}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          color: BUTTON_COLORS.BLACK,
          onClick: handleDrawerClose,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          color: BUTTON_COLORS.PRIMARY,
          disabled: loading || !edit.isValid() || !edit.isDirty(),
          onClick: handleSubmit,
        },
      ]}
      topRightClose={handleDrawerClose}
      {...rest}
    >
      <MiDetailFields
        detailFields={tradeFields}
        edit={edit}
        containerStyle={classes.container}
      />
    </MiContentDrawer>
  );
}

const useStyles = makeStyles()(() => ({
  container: {
    padding: 12,
    width: "100%",
  },
}));
